import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import {makeStyles} from 'tss-react/mui';
import {createTheme, ThemeProvider} from '@mui/material/styles';

const theme = createTheme();
const useStyles = makeStyles()((theme) => ({
   campoLabel: {
      alignSelf: 'center',
      paddingRight: '8px',
      wordWrap: 'break-word',
      minWidth: '100px',
      width: '150px',
      cursor: 'default',
      float: 'left'
   },

   contenedor: {
      display: 'flex',
      width: '100%'
   },
   campo: {
      boxSizing: 'border-box',
      float: 'right',
      width: '100%'
   }
}));
/**
 * Agrega un label en el lado derecho de un componente. Cualquier otra propiedad sera redireccionada al componente *dsComponent*
 */
function LabelComponent({dsLabel, dsComponent, dsButton, dsClassNameLabel, ...otherProps}) {
   const {classes, cx} = useStyles();
   const Component = dsComponent || TextField;

   return (
      <div className={classes.contenedor}>
         {dsLabel && (
            <Typography className={cx(classes.campoLabel, dsClassNameLabel)}>{dsLabel}:</Typography>
         )}
         <div className={classes.campo}>
            <Component {...otherProps} />
         </div>
         {dsButton}
      </div>
   );
}
LabelComponent.propTypes = {
   /**
    * Texto label a mostrar.
    */
   dsLabel: PropTypes.string,
   /**
    * Componente al cual se desea agregar el label a lado derecho. Cualquier otra propiedad sera redireccionada a este componente.
    */
   dsComponent: PropTypes.elementType,
   /**
    * Clase asignar al label del componente
    */
   dsClassNameLabel: PropTypes.string
};
export default LabelComponent;
